import { render, staticRenderFns } from "./MarketplaceRatesTableUser.vue?vue&type=template&id=620f1a3f&scoped=true"
import script from "./MarketplaceRatesTableUser.vue?vue&type=script&lang=js"
export * from "./MarketplaceRatesTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f1a3f",
  null
  
)

export default component.exports